import { render, staticRenderFns } from "./create-tag-modal.vue?vue&type=template&id=0f57050a&scoped=true"
import script from "./create-tag-modal.vue?vue&type=script&lang=js"
export * from "./create-tag-modal.vue?vue&type=script&lang=js"
import style0 from "./create-tag-modal.vue?vue&type=style&index=0&id=0f57050a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f57050a",
  null
  
)

export default component.exports